import { ThemeColor } from '@/enums'
import { Typography } from '../../atoms'
import { StyledCard } from './styles'
import { JSX } from 'react'

interface CardNodeProps {
  value: string | number
  text: string
  subtext: string
  onClick: (data: { value: string | number; text: string }) => void
}

export const CardNode = ({
  value,
  text,
  subtext,
  onClick,
}: CardNodeProps): JSX.Element => (
  <StyledCard onClick={() => onClick({ value, text })}>
    <Typography variant="captionB">{text}</Typography>
    <Typography color={ThemeColor.b50} variant="p2Body">
      {subtext}
    </Typography>
  </StyledCard>
)
